<template>
	<svg
		:alt="alt"
		xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="-1 -1 32 32">
		<path fill="none" stroke="#0074B5" d="M30,0 L30,30 L0,30 L0,0 L30,0 Z"/>
	</svg>
</template>

<script>
export default {
	props: {
		alt: String
	}
};
</script>
